<template>
	<div>
		<a-menu mode="inline" :default-selected-keys="['商会简介']" :default-open-keys="['商会管理','商会商城']" :style="{ height: '100%', borderRight: 0 }" @click="titleClick">
			<a-sub-menu key="商会管理">
				<span slot="title">
					<a-icon type="setting" />
					<span>商会管理</span>
				</span>
				<a-menu-item key="商会公告">
					<a-icon type="sound" />
					商会公告
				</a-menu-item>
				<a-menu-item key="商会动态">
					<a-icon type="star" />
					商会动态
				</a-menu-item>
				<a-menu-item key="商会成员">
					<a-icon type="usergroup-add" />
					商会成员
				</a-menu-item>
				<a-menu-item key="商会简介">
					<a-icon type="book" />
					商会简介
				</a-menu-item>
			</a-sub-menu>
			<a-sub-menu key="商会商城">
				<span slot="title">
					<a-icon type="setting" />
					<span>商会商城</span>
				</span>
				<a-menu-item key="商城分类">
					<a-icon type="sound" />
					商城分类
				</a-menu-item>
				<a-menu-item key="商品列表">
					<a-icon type="star" />
					商品列表
				</a-menu-item>
			</a-sub-menu>
			<!-- <a-menu-item key="商会分类标签">
				<a-icon type="compass" />
				商会分类标签
			</a-menu-item> -->
			<!-- <a-menu-item key="商会行业设置">
				<a-icon type="calendar" />
				商会行业设置
			</a-menu-item> -->
			<a-menu-item key="创业互助">
				<a-icon type="deployment-unit" />
				创业互助
			</a-menu-item>
			<a-menu-item key="商会荣耀">
				<a-icon type="smile" />
				商会荣耀
			</a-menu-item>
			<a-menu-item key="财务公示">
				<a-icon type="dollar" />
				财务公示
			</a-menu-item>
			<a-menu-item key="商会客服">
				<a-icon type="phone" />
				商会客服
			</a-menu-item>
		</a-menu>
	</div>
</template>

<script>
export default {
	data() {
		return {
		};
	},
	methods: {
		titleClick(item, key, keyPath) {
			this.sendData(item.key)
		},
		sendData(key) {
			this.$emit('BusinessClubMenuClick', key);
		}
	}
};
</script>

<style></style>
